import { render } from "./SubcategoryEdit.vue?vue&type=template&id=bf749e00"
import script from "./SubcategoryEdit.vue?vue&type=script&lang=js"
export * from "./SubcategoryEdit.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__